import { API_CREATE_OUTLET, API_GET_CATEGORY_TYPE_3_TAGS, API_GET_LAST_UPDATED_OUTLET_LIST, API_GET_OUTLET, API_GET_TAGS } from "constants/api";
import { api } from "./service";
import { ApiResponse, CreateOutletPayload, CreateOutletResponse, GetCategoryType3TagsResponse, GetLastUpdatedOutletListResponse, GetOutletPayload, GetTagsResponse } from "./types";

export const createOutlet = async (payload: CreateOutletPayload): Promise<ApiResponse<CreateOutletResponse>> => {
	return (await api()).post(API_CREATE_OUTLET, payload);
};

export const getLastUpdatedOutletList = async (): Promise<ApiResponse<GetLastUpdatedOutletListResponse>> => {
	return (await api()).post(API_GET_LAST_UPDATED_OUTLET_LIST);
};

export const getOutlet = async (payload: GetOutletPayload): Promise<ApiResponse<GetLastUpdatedOutletListResponse>> => {
	return (await api()).post(API_GET_OUTLET, payload);
};

export const getTags = async (): Promise<ApiResponse<GetTagsResponse>> => {
	return (await api()).post(API_GET_TAGS);
};

export const getCategoryType3Tags = async (): Promise<ApiResponse<GetCategoryType3TagsResponse>> => {
	return (await api()).post(API_GET_CATEGORY_TYPE_3_TAGS);
};
